/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GroupDtoPage } from '../../models/group-dto-page';

export interface ListGroups$Params {
  query?: string;
  userId?: string | null;
  canAssignWorkPackage?: boolean | null;
  excludeIds?: Array<string>;
  offset?: number;
  limit?: number;
  sorting?: Array<'id' | '-id' | 'groupName' | '-groupName' | 'groupDescription' | '-groupDescription' | 'canAssignWorkPackage' | '-canAssignWorkPackage' | 'usersCount' | '-usersCount' | 'globalRolesCount' | '-globalRolesCount' | 'createdAt' | '-createdAt' | 'updatedAt' | '-updatedAt'>;
}

export function listGroups(http: HttpClient, rootUrl: string, params?: ListGroups$Params, context?: HttpContext): Observable<StrictHttpResponse<GroupDtoPage>> {
  const rb = new RequestBuilder(rootUrl, listGroups.PATH, 'get');
  if (params) {
    rb.query('query', params.query, {});
    rb.query('userId', params.userId, {});
    rb.query('canAssignWorkPackage', params.canAssignWorkPackage, {});
    rb.query('excludeIds', params.excludeIds, {});
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('sorting', params.sorting, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GroupDtoPage>;
    })
  );
}

listGroups.PATH = '/v0/groups';
